import React,{ useState, useEffect }  from 'react'
import {Card} from 'react-bootstrap'
import Sides from '../Bars/Diffjvsp';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jpfunction(){


  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(3)
    } else {
      setWindowpadding(15)
    }
  }

  


return(
    <div>
   <Sides />
      <Helmet>
 
 <title>Difference Between Java and Python Function tutorial For Beginners</title>
<meta name="description" content="Difference Between Java and Python Function tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, python tutorial,python tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,Function,tutorial for begineers,Difference Between Java and Python,Difference between program and code,java tutorial for begineers,python tutorial for begineers,C# tutorial for begineers,code,exampler,which online website to learn code,Difference Between Java and python tutorial,code,exampler,java vs python Function,java vs Csharp(C#),Function"/>
<link rel="canonical" href="https://www.codeexampler.com/java-vs-python-function" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Difference Between Java and Python function</h1>
    <div className="first">
        <a href="/java-vs-python-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
       
        </div>
    <h3 className="mt-4 para">Methods in java Syntax:</h3>

    <Card className='inde' border='primary m-4'>
<Card.Header as="h5">Methods in java Syntax:</Card.Header>
<Card.Body>

<Card.Text>
<span className="yl">Method name</span>(<span className="re">parenthesis or parameter list</span>)<br/>
&#123;<br/>
&#47;&#47;body of method<br/>
&#125;<br/>

</Card.Text>

</Card.Body>

</Card>

<h3 className="mt-4">Function in Python Syntax</h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Function or method in Python Syntax</Card.Header>
  <Card.Body>
  
    <Card.Text>
   <p><span className="re">def</span> <span className="gr">names():</span><br/>
    Statement<br/>
    <span className="bl">names()</span><br/>
statement
</p>
    </Card.Text>
  </Card.Body>
</Card>

<h3 className="mt-4">Methods in java Example</h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-Use two methods and create a different object for different methods in Java Example?</Card.Header>
  <Card.Body>
    <Card.Text>
    <span className="re">class</span> <span className="yl">school</span><br/>
    &#123;<br/>
public void <span className="gr">teachers()</span><br/>
&#123;<br/>
System.out.<span className="bl">println</span>("teaching");<br/>
&#125;<br/>
public void <span className="re">students()</span><br/>
&#123;<br/>
    System.out.<span className="yl">println</span>("learn");<br/>
    &#125;<br/>
    <span className="gr">public</span> static void main(String[] args) <br/>
&#123;<br/>
    System.out.<span className="yl">println</span>("start method");<br/>
    <span className="bl">school</span> <span className="re">s</span> = new <span className="bl">school();</span><br/>
    <span className="yl">s</span>.<span className="gr">teachers ();</span> &#47;&#47; first method<br/>
    <span className="yl">s</span>.<span className="gr">students ();</span>&#47;&#47; second method<br/>
&#125;<br/>
&#125;
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/>start method<br/>
teaching<br/>
learn</Card.Footer>
</Card>

<h3 className="mt-4">Methods or function in Python Example</h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-Creating a function in Python example?</Card.Header>
  <Card.Body>
    <Card.Text>
   <p><span className="bl">def</span> <span className="re">names():</span><br/>
    print("code")<br/>
    <span className="gr">names()</span><br/>
print("Warriors")
</p>
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/>code<br/>
Warriors</Card.Footer>
</Card>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/java-vs-python-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        
        </div>
    </div>
    </div>
)

}
export default Jpfunction;